/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_State_Wrong_AccountInputs */



/**
* | output |
* | --- |
* | "This invite was sent to another email address. Sign in with that address." |
*
* @param {Invite_State_Wrong_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_state_wrong_account = /** @type {((inputs?: Invite_State_Wrong_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_State_Wrong_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This invite was sent to another email address. Sign in with that address.")
});